export const comparer = (x, y) => {

    if (x < y) {
        return -1;
    }
    else if (x > y) {
        return 1;
    }
    else {
        return 0;
    }

}

export const areArraySame = (x, y) => {
    if (x.length !== y.length) {
        return false;
    }

    for (var index = 0; index < x.length; index++) {
        if (x[index] !== y[index]) {
            return false;
        }
    }

    return true;
}